import logo from './logo.svg';
// import './App.css';
import 'antd/dist/antd.min.css'

import AppRouter from "./Router";

function App() {
  return (
    <div className="App" style={{"marginTop": "30px"}}>
      <AppRouter />
      {/* <FindingRelevantResearchersBasedOnLikedPapers/> */}
      {/* <FindMatches/> */}
    </div>
  );
}

export default App;
